import { useContext } from 'react';
import { StaticContext } from '@sm/webassets';

import { GUAC_COUNTRY_CODES } from './constants';

/**
 * TODO: Delete after we have converted the usage to TS
 * Creates a className friendly string from a package label
 *
 * @param {PlaceHolderType} packageObj The package object to create the class name from
 * @return The label name, ready to be used as a className
 */
export function packageLabelToClassName(packageObj) {
  return packageObj.label.trim().replace(/\s/g, '-').toLowerCase();
}

/* eslint-disable react-hooks/rules-of-hooks */

/**
 * TODO: Refactor into a ts file  hook, create a hook folder
 * Used as part of a feature's `hidden` property to limit its
 * display to only GB, US, AU, and CA.
 *
 * NOTE: Uses react hooks, so can only be called from within a
 *       react component. Do not use outside of a package feature's
 *       `hidden` getter.
 *
 * @return {boolean}
 */
export function featureIsGuacOnly() {
  const {
    environment: { countryCode },
  } = useContext(StaticContext);
  return !GUAC_COUNTRY_CODES.includes(countryCode.toLowerCase());
}

/**
 * TODO: Refactor to ts
 * Used as part of a feature's `hidden` property to limit its
 * display to non GB, US, AU, or CA countries
 *
 * NOTE: Uses react hooks, so can only be called from within a
 *       react component. Do not use outside of a package feature's
 *       `hidden` getter.
 *
 * @return {boolean}
 */
export function featureIsNonGuacOnly() {
  return !featureIsGuacOnly();
}

/* eslint-enable react-hooks/rules-of-hooks */
